import { Input } from 'antd';
import styled from 'styled-components';
import { SearchProps } from 'antd/es/input';

export const StyledSearchInput = styled(Input.Search)`
  width: 100%;
`;

interface Props extends SearchProps {}

function SearchInput(props: Props) {
  return <StyledSearchInput {...props} />;
}

export default SearchInput;
